import React from 'react'
import { Container, Title } from './styles'
import { message } from '~/services'

export const Header = (): JSX.Element => {
  return (
    <Container>
      <Title>{message('feedback.help_us')}</Title>
    </Container>
  )
}
